import React from 'react'
import { AsgPageBackDropProps } from './types'
import { path } from '@/core/utils'
import { useApp } from '@/core/contexts/app'
import { useWidth } from '@/core/hooks/useWidthResize'

const AsgPageBackDrop: React.FunctionComponent<AsgPageBackDropProps> = (
  props
) => {
  const app = useApp()
  const width = useWidth()
  return (
    <div
      className={`asg-page-backdrop ${width <= 768 && 'mobile'}`}
      style={{
        backgroundImage: `url(${path.asset(
          app.environment,
          width > 768 ? props.image?.src : props.mobileImage?.src || ''
        )})`,
      }}
    ></div>
  )
}

export default AsgPageBackDrop
